module.exports = __webpack_public_path__ + "img/footer_logo6.57e9e055.jpg";